import { DialogFooter, DialogHeader, DialogTitle, Button } from '@/shared/ui'
import { cn } from '@/true-fsd/shared/utils/css'
import classes from './ConfirmCloseDialog.module.scss'

/**
 * Пропсы для диалога подтверждения закрытия редактора
 */
export interface ConfirmCloseDialogProps {
    /**
     * Открыт ли диалог
     */
    open: boolean

    /**
     * Обработчик изменения состояния открытия
     */
    onOpenChange: (open: boolean) => void

    /**
     * Обработчик подтверждения закрытия (закрыть без сохранения)
     */
    onConfirm: () => void

    /**
     * Обработчик отмены (вернуться в редактор)
     */
    onCancel: () => void
}

/**
 * Диалог подтверждения закрытия редактора маркировки
 * Показывается при попытке закрыть редактор с несохраненными изменениями
 * Рендерится внутри родительского модального окна с абсолютным позиционированием
 */
export function ConfirmCloseDialog({
    open,
    onOpenChange,
    onConfirm,
    onCancel,
}: ConfirmCloseDialogProps) {
    if (!open) {
        return null
    }

    const handleConfirm = () => {
        onConfirm()
        onOpenChange(false)
    }

    const handleCancel = () => {
        onCancel()
        onOpenChange(false)
    }

    return (
        <>
            <div
                className={classes.overlay}
                onClick={handleCancel}
                style={{ pointerEvents: 'auto' }}
            />
            <div
                className={cn(classes.dialogContent, classes.dialogWrapper)}
                style={{ pointerEvents: 'auto' }}
            >
                <DialogHeader className={classes.header}>
                    <DialogTitle className={classes.title}>
                        Закрыть без сохранения?
                    </DialogTitle>
                </DialogHeader>

                <DialogFooter className={classes.footer}>
                    <Button
                        className={classes.button}
                        variant="secondary"
                        onClick={handleCancel}
                    >
                        Нет
                    </Button>

                    <Button
                        className={classes.button}
                        variant="primary"
                        onClick={handleConfirm}
                        style={{
                            backgroundColor: '#056FFF',
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = '#1D4ED8'
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = '#056FFF'
                        }}
                    >
                        Да
                    </Button>
                </DialogFooter>
            </div>
        </>
    )
}
